import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { styles } from './styles';
import { Hero } from './components/Hero';
import { Booking } from './components/Booking';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Reviews } from './components/Reviews';
import Navbar from './components/Navbar';
import { Specialties } from './components/Specialties';
import { PersonalVideo } from './components/PersonalVideo';
import Atmosphere from './components/Atmosphere';
import MaestraDashboard from './components/MaestraDashboard';
import StudentDashboard from './components/StudentDashboard';
import ResetPassword from './components/ResetPassword';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';


const MAESTRA_EMAIL = 'sayciao.school@outlook.com';

// Wraps the app so we can read location inside Router
const AppInner = ({ session }) => {
  const location  = useLocation();
  const isMaestra = session?.user?.email?.toLowerCase() === MAESTRA_EMAIL.toLowerCase();
  const isPortal  = location.pathname === '/portal' || location.pathname === '/reset-password';

  return (
    <div style={styles.wrapper}>
<Navbar styles={styles} fixed={!isPortal} isMaestra={isMaestra} />
      <Routes>
      <Route path="/" element={
  <div style={{ paddingTop: session ? '65px' : '104px', width: '100%' }}>
    <Hero styles={styles} />
    <About styles={styles} />
    <PersonalVideo />
    <Specialties styles={styles} />
    {!session && <Booking />}
    <Reviews styles={styles} />
    <Contact />
  </div>
} />

        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/portal" element={
          !session ? (
            <StudentDashboard user={null} />
          ) : isMaestra ? (
            <MaestraDashboard />
          ) : (
            <StudentDashboard user={session.user} />
          )
        } />

        <Route path="/admin"   element={<Navigate to="/portal" replace />} />
        <Route path="/lessons" element={<Navigate to="/portal" replace />} />
        <Route path="/privacy" element={
  <div style={{ paddingTop: '65px' }}>
    <PrivacyPolicy />
  </div>
} />        <Route path="/terms" element={
  <div style={{ paddingTop: '65px' }}>
    <TermsOfService />
  </div>
} />

      </Routes>

      {/* Hide Atmosphere on portal — students are studying! */}
      {!isPortal && <Atmosphere />}

      <Footer styles={styles} />
    </div>
  );
};

const App = () => {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <Router>
      <AppInner session={session} />
    </Router>
  );
};

export default App;